module.exports = "/_next/static/images/investalt-100f8ddcd673f75751807fb9f8543fbe.svg";